"use client"
import { ApplicationEnvironmentMolecule } from "@/app/env/store"
import { Amplitude } from "@/app/infra/amplitude"
import { initPosthog } from "@/app/infra/posthog"
import { Trans } from "@lingui/react/macro"
import { reatomComponent } from "@reatom/react"
import { useMolecule } from "bunshi/react"
import { type PropsWithChildren, useEffect } from "react"
import { LoggerMolecule } from "./logger/logger-molecule"
import { LoggerScopeProvider } from "./logger/logger-scope-provider"

export const InstrumentationProvider = reatomComponent<PropsWithChildren>(
  ({ children }) => {
    const { posthogKey, posthogHost } = useMolecule(
      ApplicationEnvironmentMolecule,
    )
    // Runs during render (not in an effect) so PostHog is ready before
    // descendant effects, such as the Privy identify call, read it.
    initPosthog(posthogKey, posthogHost)

    return (
      <LoggerScopeProvider>
        <Amplitude />
        {children}
      </LoggerScopeProvider>
    )
  },
  "InstrumentationProvider",
)

export const InstrumentationFallback = reatomComponent<{ error: unknown }>(
  ({ error }) => {
    const faro = useMolecule(LoggerMolecule)

    useEffect(() => {
      faro?.api.pushError(error as Error, {
        context: { source: "instrumentation-fallback" },
      })
    }, [faro, error])

    return (
      <div className="flex h-full flex-col items-center justify-center">
        <div className="flex flex-1 flex-col items-center justify-center gap-4">
          <div className="flex max-w-[600px] flex-col items-center gap-2 px-4">
            <div className="flex flex-col items-center gap-1">
              <h2 className="text-center text-2xl">
                <Trans>Uh-oh! Something went wrong</Trans>
              </h2>
              <span className="text-center text-foreground/60">
                <Trans>
                  Give it another try. If that doesn't work, check back in a few
                  minutes.
                </Trans>
              </span>
            </div>
          </div>
        </div>
      </div>
    )
  },
  "InstrumentationFallback",
)

export function TrackInitFinished({ children }: PropsWithChildren) {
  // const value = useTrace()
  // useEffect(() => {
  //   if (value) {
  //     const { cache } = value
  //     const span = cache.get("init")
  //     span?.end()
  //   }
  // }, [value])

  return <>{children}</>
}
